import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Overlayable} from "../../interfaces/overlayable";
import {StoryShareOverlayData} from "../story-share-overlay-data";
import {StoryService} from "../../story/story.service";

@Component({
  selector: 'brt-story-share-overlay',
  templateUrl: './story-share-overlay.component.html',
  styleUrls: ['./story-share-overlay.component.scss']
})
export class StoryShareOverlayComponent implements Overlayable {
  @Output('onClosed') onClosed = new EventEmitter<boolean>();

  @Input('data') set setData(data: StoryShareOverlayData) {
    if(data) {
      this.data = data;
      this.updateShareUrl();
    }
  }
  data: StoryShareOverlayData = {
    storyId: -1,
    cardIndex: -1,
    totalCards: -1
  };
  shareUrl = "";
  isLinkCopied = false;
  addCardIndex = false;


  constructor(private storyService: StoryService) {
  }

  updateShareUrl() {
    const hash = this.storyService.getStoryHashLink(this.data.storyId, this.addCardIndex ? this.data.cardIndex : 1);
    const url = new URL(window.location.href);
    url.hash = hash;
    this.shareUrl = url.href;
    this.isLinkCopied = false;
  }

  onInputChanged($event: Event) {
    const target = $event.target as HTMLInputElement;
    this.addCardIndex = target.checked;
    this.updateShareUrl();
  }

  copyShareLinkToClipboard() {
    window.navigator.clipboard.writeText(this.shareUrl).then(() => {
      this.isLinkCopied = true;

      setTimeout(() => {
        this.isLinkCopied = false;
      }, 5000);
    }).catch((err) => {console.log(err)});
  }
}
